<template>
    <transition name="confirm-dialog">
        <div v-if="visible" class="confirm-dialog__overlay" @click.self="cancel">
            <div class="confirm-dialog" role="alertdialog" aria-modal="true">
                <div class="confirm-dialog__title" :class="'confirm-dialog__title--' + variant">
                    <i v-if="variantIcon" :class="variantIcon"></i>
                    {{ title }}
                </div>
                <div class="confirm-dialog__message">{{ message }}</div>
                <div class="confirm-dialog__actions">
                    <button
                        type="button"
                        class="confirm-dialog__btn confirm-dialog__btn--cancel"
                        @click="cancel"
                    >{{ cancelText }}</button>
                    <button
                        ref="okButton"
                        type="button"
                        class="confirm-dialog__btn confirm-dialog__btn--ok"
                        :class="{ 'confirm-dialog__btn--danger': variant === 'danger' }"
                        @click="accept"
                    >{{ okText }}</button>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
// Reemplazo tematizable del confirm() nativo. No se usa directamente: se abre
// via this.$confirm(message, options) — ver el plugin ./confirm.js.
export default {
  name: 'ConfirmDialog',
  data() {
    return {
      visible: false,
      title: '',
      message: '',
      okText: '',
      cancelText: '',
      variant: 'primary',
      resolver: null,
    };
  },
  computed: {
    variantIcon() {
      return this.variant === 'danger' ? 'bi bi-exclamation-triangle-fill' : '';
    },
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.onKeydown);
  },
  methods: {
    // Devuelve una Promise<boolean>: true = aceptar, false = cancelar.
    open(message, options = {}) {
      // Una llamada nueva con un dialogo abierto resuelve la anterior como cancelada.
      if (this.resolver) this.resolver(false);
      this.message = message;
      this.title = options.title || 'Confirmar';
      this.okText = options.okText || 'Aceptar';
      this.cancelText = options.cancelText || 'Cancelar';
      this.variant = options.variant || 'primary';
      this.visible = true;
      document.addEventListener('keydown', this.onKeydown);
      this.$nextTick(() => {
        if (this.$refs.okButton) this.$refs.okButton.focus();
      });
      return new Promise(resolve => { this.resolver = resolve; });
    },
    close(result) {
      this.visible = false;
      document.removeEventListener('keydown', this.onKeydown);
      if (this.resolver) {
        this.resolver(result);
        this.resolver = null;
      }
    },
    accept() { this.close(true); },
    cancel() { this.close(false); },
    onKeydown(e) {
      if (e.key === 'Escape') this.cancel();
    },
  },
};
</script>
